// src/admin/packType.js
//
// Single source of truth for canonical packType values + normalization.
// Canonical values match src/config/studyPacks.js + the seeds:
//   'set-text' | 'literature-study' | 'skills-workshop'
//
// Why this exists: the admin Edit <select> used non-canonical option values
// (set_text / literature / mixed) while packs are stored with canonical kebab values.
// A stored 'literature-study' matched no option, the select fell back to the first
// option, and Save then DRIFTED the stored packType (a launch blocker for Danielle
// editing a literature pack). This helper canonicalises on both read (form init) and
// write (save), and PackDetailView.getDetailPackType delegates here so there is ONE
// normalizer, not two divergent ones.
//
// Pure module (no React/JSX) so it imports cleanly into the functions test runner.

// Canonical option list for the admin dropdown (canonical value + human label).
export const PACK_TYPE_OPTIONS = [
    { value: 'set-text', label: 'Set Text' },
    { value: 'literature-study', label: 'Literature Study' },
    { value: 'skills-workshop', label: 'Skills Workshop' },
    { value: 'poetry-anthology', label: 'Poetry Anthology' },
    { value: 'series', label: 'Series (bundle of packs)' }
];

// Normalize ANY stored / legacy / user-entered packType to one canonical value.
// Handles legacy 'set_text'/'literature' and the cancelled 'mixed' (-> 'set-text').
// Behaviour matches the previous getDetailPackType exactly (plus a harmless .trim()).
// 'series' (Series/Bundle S1) MUST round-trip unchanged: before it was registered
// here, the fall-through coerced it to 'set-text' and an admin Save then silently
// rewrote the stored packType (the drift bug this module exists to prevent).
export function normalizePackType(value) {
    const v = String(value || '').trim().toLowerCase().replace(/_/g, '-');
    if (v === 'skills-workshop') return 'skills-workshop';
    if (v === 'literature' || v === 'literature-study') return 'literature-study';
    if (v === 'poetry-anthology') return 'poetry-anthology';
    if (v === 'series') return 'series';
    return 'set-text';
}
